// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__30b26","productName":"Table_productName__1MsbT"};